module.exports = __webpack_public_path__ + "static/media/ios-contacts.7a65f865.svg";